import { NextSalesPotentialDto } from '../../registration/models';
import {
  SalesPotentialActions,
  SalesPotentialActionTypes,
} from '../actions/sales-potential.actions';

export interface SalesPotentialState {
  salesPotentials: NextSalesPotentialDto[];
  loading: boolean;
  error: Error | null;
}

const initialState: SalesPotentialState = {
  salesPotentials: [],
  loading: false,
  error: null,
};

export const salesPotentialReducer = (
  state: SalesPotentialState = initialState,
  action: SalesPotentialActions,
): SalesPotentialState => {
  switch (action.type) {
    case SalesPotentialActionTypes.LoadSalesPotentialsRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SalesPotentialActionTypes.LoadSalesPotentialsSuccess:
      return {
        ...state,
        salesPotentials: action.payload,
        loading: false,
        error: null,
      };

    case SalesPotentialActionTypes.LoadSalesPotentialsFailed:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SalesPotentialActionTypes.DeleteSalesPotentialRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SalesPotentialActionTypes.DeleteSalesPotentialSuccess:
      return {
        ...state,
        salesPotentials: state.salesPotentials.filter((sp) => sp.id !== action.payload),
        loading: false,
        error: null,
      };

    case SalesPotentialActionTypes.DeleteSalesPotentialFailed:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SalesPotentialActionTypes.UpsertSalesPotentialRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SalesPotentialActionTypes.UpsertSalesPotentialSuccess: {
      const existingIndex = state.salesPotentials.findIndex((sp) => sp.id === action.payload.id);
      const updatedSalesPotentials =
        existingIndex >= 0
          ? [
              ...state.salesPotentials.slice(0, existingIndex),
              action.payload,
              ...state.salesPotentials.slice(existingIndex + 1),
            ]
          : [...state.salesPotentials, action.payload];

      return {
        ...state,
        salesPotentials: updatedSalesPotentials,
        loading: false,
        error: null,
      };
    }

    case SalesPotentialActionTypes.UpsertSalesPotentialFailed:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
